import clsx from "clsx";
import { TagItem } from "./ScheduleListDay";
import React from "react";

export const DayTags = ({ tags }: { tags: TagItem[] }): JSX.Element => {
  return (
    <div className="flex flex-wrap gap-2">
      {tags.map((item, idx) => (
        <div
          key={idx}
          className={clsx(
            "flex bg-white justify-center items-center w-[60px] h-[30px] gap-2",
            { "rounded-full": item.roundedFull },
            { rounded: item.rounded },
            item.tagClassName
          )}
        >
          {item.tag && (
            <span className="text-14 font-bold text-black">{item.tag}</span>
          )}
          {item.tagIcon && (
            <img
              className={clsx("flex-none w-5 h-auto", item.tagIconClassName)}
              src={item.tagIcon}
              alt="Иконка тега"
            />
          )}
        </div>
      ))}
    </div>
  );
};
